import * as React from "react";
import { Overlay } from "react-bootstrap";
import CustomPopover from "./CustomPopover";

const styles = require("./styles.module.scss");

interface ColumnPickerProps {
  showColumn: Function;
  hideColumn: Function;
  displayText: Function;
  shownColumns: string[];
  hiddenColumns: string[];
  saveSettings: Function;
  resetSettings: Function;
  clearSettings: Function;
}

interface ColumnPickerState {
  showingMenu: boolean;
}
class ColumnPicker extends React.Component<ColumnPickerProps, ColumnPickerState> {
  state = {
    showingMenu: false,
  };

  handleToggle = () => {
    this.setState(prevState => ({ showingMenu: !prevState.showingMenu }));
  };

  private target;

  render() {
    const { showingMenu } = this.state;
    const sharedProps = {
      container: this.target,
      target: this.target,
      show: showingMenu,
    };
    return (
      <span
        className={styles.columnPickerIcon}
        ref={element => {
          this.target = element;
        }}
      >
        <button
          type="button"
          className="btn btn-link"
          onClick={this.handleToggle}
          onMouseEnter={() => this.setState({ showingMenu: true })}
        >
          <i className="fa fa-gear" />
        </button>

        {showingMenu && (
          <Overlay {...sharedProps} placement="left">
            <CustomPopover
              {...this.props}
              onMouseLeave={() => this.setState({ showingMenu: false })}
            />
          </Overlay>
        )}
      </span>
    );
  }
}

export default ColumnPicker;
